import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile(initial = false) {
  // `initial` seeds the SSR + first-client-render value. Pass a server-derived
  // guess (e.g. a User-Agent hint) so the first paint already matches the
  // device — this avoids the layout shift that a hard `false` default caused on
  // /products, where every phone rendered the desktop grid first and only
  // swapped to the mobile layout after mount (a CLS ranking hit). The value
  // MUST be identical on server and client (pass the same prop) or hydration
  // mismatches. `useEffect` still corrects it from `matchMedia` after mount, so
  // a wrong guess self-heals for the minority of UA/viewport mismatches.
  const [isMobile, setIsMobile] = React.useState(initial)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    // eslint-disable-next-line react-hooks/set-state-in-effect -- synchronises the SSR device guess with matchMedia after hydration.
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isMobile
}
